export default __webpack_public_path__ + "static/media/notfound.71887a92.jpg";